import { Button } from "./Button";
export const MemoList = ({ memos, onDelete }) => {
  return (
    <div className="list-area">
      <p className="title">一覧</p>
      <div className="list-text">
        <ul>
            {memos.map((memo) => (
            <li key={memo.id}>
                {/* テキストを表示 */}
                {memo.text}

                {/* IDを使って削除対象を特定 */}
            <Button onClick={() => onDelete(memo.id)}>
                削除
            </Button>
            </li>          
            ))}
        </ul>
      </div>
    </div>
  );
};